<template>
    <div ref="filters" id="filters" v-if="hasSlot('content')">
        <div class="filters-content" @click="toggle()">
            <slot name="content" />
        </div>
        <div class="filters-dropdown" :class="[align]" v-if="isActive" ref="filterDropdown">
            <div class="filter-dropdown-head">
                <div class="filter-dropdown-back">
                    <span class="material-icons" @click="back()">
                        {{ operators || selectedInput || !selectable ? "arrow_back_ios" : "" }}
                    </span>
                </div>
                <div class="title">{{ $t('message.filters') }}</div>
                <span
                    class="material-icons"
                    style="font-size: 22px; font-weight: bold; cursor: pointer"
                    @click="toggle()"
                    >close</span
                >
            </div>
            <div
                class="filter-dropdown-content"
                :style="{
                    transform: operators ? 'translate(-600px)' : selectedInput ? 'translate(-300px)' : 'translate(0)',
                }"
            >
                <div class="filter-dropdown-first item">
                    <div class="filters-items">
                        <div class="filters-item" v-for="item of data">
                            <div class="filters-item-name" @click="select(item)">
                                <div class="material-icons">{{ item.material_icons }}</div>
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="filter-dropdown-second item">
                    <div class="filters-items" v-if="selectedItem && selectedItem.inputs[0].type == 'select'">
                        <div class="filters-item" v-for="option of selectedItem.inputs[0].data">
                            <div class="filters-item-name" @click="selectInput(option.key)">
                                {{ option.value }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="filter-dropdown-third item">
                    <div class="filters-items">
                        <div class="filters-item" v-for="operator of getOperators()">
                            <div class="filters-item-name" @click="selectOperator(operator)">
                                {{ OPERATORS_TYPES[operator] }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import MiniFilterPreview from "./MiniFilterPreview.vue";

const INPUT_TYPES = {
    TEXT: "text",
    SELECT: "select",
    DATE: "date",
};

const OPERATORS_TYPES = {
    is: "Eşit",
    is_not: "Eşit Değil",
    contains: "İçerir",
    not_contains: "İçermez",
    starts_with: "ile Başlar",
    ends_with: "ile Biter",
};

const PERIOD_TYPES = {
    TODAY: "today",
    YESTERDAY: "yesterday",
    THIS_WEEK: "thisWeek",
    PAST_WEEK: "pastWeek",
    THIS_MONTH: "thisMonth",
    PAST_MONTH: "pastMonth",
    CUSTOM: "custom",
};

export default {
    name: "Filters",
    components: {
        MiniFilterPreview,
    },
    props: {
        align: {
            type: String,
            default: "top",
        },
        data: {
            type: Array,
            default: () => [],
        },
        active: {
            type: Boolean,
            default: false,
        },
        defaultFilters: {
            type: Array,
            default: () => [],
        },
    },
    data: () => {
        return {
            INPUT_TYPES,
            OPERATORS_TYPES,
            PERIOD_TYPES,
            isActive: false,
            selectable: true,
            filters: [],
            filtered: [],
            operators: false,
            selectedItem: null,
            selectedInput: false,
        };
    },
    computed: {
        isEqual() {
            return _.isEqual(this.filtered, this.formatedFilters());
        },
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
            if (this.isActive) this.$refs.filters?.focus();
        },
        back() {
            this.selectedInput = false;
            this.operators = false;
            this.selectable = true;
            this.selectedItem = null;
        },
        hasSlot(name) {
            return !!this.$slots[name];
        },
        selectedFilters(item) {
            this.filters = [
                ...this.filters,
                {
                    ...item,
                    inputs: item.inputs.map((input) => {
                        if (input.periods) input.period = PERIOD_TYPES.TODAY;
                        return {
                            ...input,
                            value: input.value
                                ? input.value
                                : input.type == INPUT_TYPES.SELECT
                                ? input.multiple
                                    ? [input.data[0]?.key]
                                    : input.data[0]?.key
                                : null,
                        };
                    }),
                },
            ];
            this.$emit("filtered", this.filters);
            this.selectable = true;
            this.isActive = false;
            this.selectedItem = null;
        },
        select(item) {
            if (item.inputs[1]) {
                this.selectedInput = true;
                this.selectedItem = item;
                return;
            } else if (item.operators) {
                this.operators = true;
                item.rule = null;
                this.selectedItem = item;
                return;
            }
            this.selectedFilters(item);
        },
        getOperators() {
            const usedOperators =
                (this.selectedItem && this.filters.filter((f) => f.key == this.selectedItem.key).map((f) => f.rule)) ||
                [];
            return Object.keys(OPERATORS_TYPES).filter(
                (operator) => ![...usedOperators, ...(this.selectedItem?.disableOperators || [])].includes(operator)
            );
        },
        selectInput(key) {
            this.selectedItem.inputs[0].value = key;
            this.selectedInput = false;
            if (this.selectedItem.operators) {
                this.operators = true;
                return;
            }
            this.selectedFilters(this.selectedItem);
        },
        selectOperator(rule) {
            this.selectedItem.rule = rule;
            this.operators = false;
            this.selectedFilters(this.selectedItem);
        },
    },
    mounted() {
        if (!this.hasSlot("content")) {
            console.error('Syntax Error: <template name="content"><button>Click</button></template> missing..');
            return;
        }
        const flattenFilters = this.data.map((f) => f.inputs).flat();
        const filtersTypes = flattenFilters.map((f) => f.key);
        const duplicateKey = filtersTypes.find((key, index) => filtersTypes.indexOf(key) !== index);
        if (duplicateKey) {
            console.warn("[Filter Component] Duplicate 'key' founded: " + duplicateKey);
            return;
        }
        document.addEventListener("click", (e) => {
            if (!this.$refs.filters?.contains(e.target)) {
                this.isActive = false;
            }
        });
        this.isActive = !!this.active;
        this.filters = [...this.defaultFilters];
    },
    watch: {
        active() {
            if (this.active !== this.isActive) {
                this.isActive = !!this.active;
                this.selectable = false;
            }
        },
        isActive(newVal) {
            if (this.active !== this.isActive) {
                this.$emit("changeActive", newVal);
            }
        },
        defaultFilters(val) {
            this.filters = val;
        },
    },
};
</script>
<style lang="scss">
#filters {
    position: relative;
    width: 100%;
    user-select: none;
    display: block;

    span {
        display: block;
    }
    .filter-dropdown-back {
        .material-icons {
            cursor: pointer;
        }
    }
    .filters-dropdown {
        position: absolute;
        background-color: white;
        border: 1px solid #dddddd;
        border-radius: 4px;
        width: 300px !important;
        z-index: 9999;
        overflow: hidden;

        .filter-dropdown-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 13px;
            background: var(--color-bg-neutral-default);
            .material-icons {
                font-size: 18px;
                font-weight: bold;
            }
            .title {
                font-size: 16px;
                font-weight: bold;
            }
        }
        &.bottom {
            top: calc(100% + 4px);
        }
        &.top {
            bottom: calc(100% + 4px);
        }
        .filters-head {
            display: flex;
            width: 300px !important;
            align-items: center;
            justify-content: center;
            background: #1e1e2d;
            padding: 4px 15px;
            border-radius: 5px 5px 0px 0px;
            color: white;
            font-weight: bold;
            font-size: 14px;
        }
        .filter-dropdown-content {
            width: 300px;
            display: flex;
            transition: all 0.3s ease 0s;
            .item {
                min-width: 300px;
            }
        }
        .filters-items {
            height: 350px;
            overflow: auto;
            .filters-item {
                padding: 8px 20px;
                color: #1e1e2d;
                border-bottom: 1px solid #1e1e2d;
                &:last-child {
                    border: none;
                }
                &:hover {
                    background-color: #1e1e2d;
                    color: white;
                }
                .material-icons {
                    margin-right: 10px;
                }
            }
            .filters-item-name {
                display: flex;
                align-items: center;
                font-size: 16px;
                cursor: pointer;
            }
        }
    }
}
</style>
